import React, { useState } from 'react';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { getDepartments } from '../../network/practitioners';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { ModalAppDepartments } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteDepartments } from '../../network/Departments';
import { PlusOutlined } from '@ant-design/icons';

const Departments = ({ t }) => {
  const client = useQueryClient();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (data) => deleteDepartments(data),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Record successfully deleted!');
        // message.success(data?.message?.message);
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({
          queryKey: [queryKeys.getDepartmentsList],
        });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title: t.departmentName,
      dataIndex: 'department',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.department).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.patientCareType,
      dataIndex: 'patient_care_type',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        //  console.log('record:', record);
        return (
          <Space>
            {/* <ModalAppDepartments
               t={t}
               edit={true}
              //  record={record.department}
              record={editId}
               /> */}
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.department);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheDepartment}
              description={t.areYouSure}
              onConfirm={() =>
                handleRemove.mutate({
                  record: record?.department,
                  key: 'Medical Department',
                })
              }
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getDepartmentsList],
    queryFn: () => getDepartments(),
    keepPreviousData: true,
  });
  const dataTable = data?.message?.departments?.map((item, index) => {
    // console.log('item:', item);
    return {
      key: index,
      department: item.department,
      //  patient_care_type: item.patient_care_type || item?.name,
      patient_care_type: item.patient_care_type,
    };
  });
  return (
    <div className="departments">
      <Heading title={t.settings} subTitle={t.department} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addDepartment}
        Placeholder={t.searchDepartment}
        // pathBtn="/departments/add"
        // buttonModal={<ModalAppDepartments t={t} edit={false} />}
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined size={10} /> {t.addDepartment}
          </Button>
        }
      />
      <ModalAppDepartments
        t={t}
        edit={edit}
        open={open}
        setOpen={setOpen}
        record={editId}
      />
    </div>
  );
};

export default Departments;
